/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import e from"../config.js";const o=()=>e.respectPrefersReducedMotion&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;export{o as prefersReducedMotion};
